import * as React from 'react';
import TouchSlider from './TouchSlider';
import EchoDisplay from './EchoDisplayGL';

const EchoView = ({ setParam, params }) => {
	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<div style={{ width: '100%', height: '55%', margin: 'auto' }}>
				<EchoDisplay mix={params.MIX} fdbk={params.FDBK} time={params.TIME} />
			</div>
			{Object.keys(params).map(key => (
				<div key={key} style={{ height: '14%' }}>
					<TouchSlider
						defaultValue={params[key]}
						setValue={v => setParam(key, v)}
						min={0}
						max={key=="TIME"?4:1}
						label={key}
					/>
				</div>
			))}
		</div>
	);
};

export default EchoView;
